import { MicOffIcon, TvIcon, VideoOffIcon } from "lucide-react";

import { useIsModerator } from "../api/is-moderator";
import { Participant } from "../types/participant";

import { ParticipantItemAction } from "./participant-item-action";

type ParticipantItemProps = {
  participant: Participant;
};
export function ParticipantItem({ participant }: ParticipantItemProps) {
  const isModerator = useIsModerator();

  return (
    <li className="flex items-center justify-between px-4 py-2 text-sm text-foreground">
      <span className="flex items-center">
        {participant.isRoomSystem ? (
          <TvIcon className="mr-2 size-4 rotate-180 text-muted-foreground" />
        ) : null}
        {participant.name}
        <span className="ml-2 text-muted-foreground">
          {participant.isCurrentUser ? "(You)" : ""}
        </span>
        {participant.isVideoEnabled ? null : (
          <VideoOffIcon className="ml-2 size-4 text-muted-foreground" />
        )}
        {participant.isAudioEnabled ? null : (
          <MicOffIcon className="ml-2 size-4 text-muted-foreground" />
        )}
      </span>
      {/* Don't show the action button for the current user */}
      {!participant.isCurrentUser && isModerator ? (
        <ParticipantItemAction participant={participant} />
      ) : (
        <div className="size-9 bg-transparent" />
      )}
    </li>
  );
}
